import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Hide platform badge
const hideBadge = () => {
  const el = document.getElementById('emergent-badge');
  if (el) el.remove();
};
hideBadge();
const obs = new MutationObserver(hideBadge);
obs.observe(document.body, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
